import { ChatMessageBase } from "../../molecules/ChatMessageBase/ChatMessageBase";
import React from "react";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";
import { MarkdownRenderer } from "@me8eon/markdown_renderers";

type Props = {
    message: MessageWithActionAndData;
    isLast: boolean;
    isStreaming?: boolean;
}

export const AssistantMessageComponent: React.FC<Props> = ({ message, isLast, isStreaming }) => {
    if (message.toolCalls) return <></>;
    if (typeof message.content !== "string") return <></>;
    if (message.content.length === 0 && !isStreaming) return <></>;

    return (
        <ChatMessageBase
            content={
                <div>
                    {message.content.length > 0 && (
                        <MarkdownRenderer
                            value={message.content}
                            attribute={"assistant"}
                            rootId={crypto.randomUUID()}
                        />
                    )}
                </div>
            }
            variant={"assistant"}
            isLast={isLast}
            disableActions={Boolean(isStreaming)}
        />
    );
};